import easterImage from '../content/assets/index/easter.jpg'
import summerHolidayImage from '../content/assets/index/summer_holiday.jpg'
import winterHolidayImage from '../content/assets/index/winter_holiday.jpg'
import calendarCheckIcon from '../content/assets/flexiblocks/icons/bx-calendar-check.svg'
import checkCircleIcon from '../content/assets/flexiblocks/icons/bx-check-circle.svg'
import directionsIcon from '../content/assets/flexiblocks/icons/bx-directions.svg'

const ICON_COLOR = '#60a5fa'
const ICON_BG = 'transparent'

const icons = {
  calendar: calendarCheckIcon,
  directions: directionsIcon,
  check: checkCircleIcon
}

export const occasionPresets = {
  easter: {
    occasion: 'Osterurlaub',
    title: 'Wegen Osterurlaub geschlossen',
    image: {
      src: easterImage,
      alt: 'Osterurlaub'
    }
  },
  summer: {
    occasion: 'Sommerurlaub',
    title: 'Wegen Sommerurlaub geschlossen',
    image: {
      src: summerHolidayImage,
      alt: 'Sommerurlaub'
    }
  },
  autumn: {
    occasion: 'Herbstferien',
    title: 'Wegen Herbstferien geschlossen',
    image: {
      src: summerHolidayImage,
      alt: 'Herbstferien'
    }
  },
  christmas: {
    occasion: 'Weihnachtsurlaub',
    title: 'Wegen Weihnachtsurlaub geschlossen',
    image: {
      src: winterHolidayImage,
      alt: 'Weihnachtsurlaub'
    }
  }
}

export const advertisement = {
  preset: 'christmas',
  closed: {
    from: '24.12.2026',
    to: '01.01.2027'
  },
  reopens: {
    weekday: 'Montag',
    date: '04.01.2027'
  },
  substitutes: [
    {
      name: 'Dr. Kröger',
      details: 'Nordring 17-21, Bünde, 05223-3717',
      enabled: false
    },
    {
      name: 'Dr. Weil',
      details: 'Herforder Str. 3, Bünde, 05223-2530',
      enabled: false
    },
    {
      name: 'Dr. Könemann',
      details: 'Wilhelmstr. 27, Bünde, 05223-14438',
      enabled: true
    },
    {
      name: 'Dr. Diekmann / Dr. Hense',
      details: 'Herforder Str. 35, Bünde, 05223-2766',
      enabled: true
    },
    {
      name: 'Dr. Kammann',
      details: 'Bahnhofstr. 57, Bünde, 05223-3120',
      enabled: false
    },
    {
      name: 'Dr. Allouch',
      details: 'Hangbaumstr. 15, Bünde, 05223-12060',
      enabled: false
    }
  ],
  emergencyText:
    'An den Wochentagen (Mo, Di, Do ab 18 Uhr. Mi, Fr ab 13 Uhr), sowie am gesamten Wochenende bitten wir Sie sich an die Zentrale Notfallpraxis in Bünde (Hindenburgstraße 56) unter folgender Rufnummer zu wenden: 05223-19292 oder 116117',
  signature: 'Ihr Praxisteam'
}

const icon = src => ({
  src,
  color: ICON_COLOR,
  bg: ICON_BG
})

const text = (value, options = {}) => ({
  text: value,
  ...options
})

const listItem = (iconSrc, lines) => ({
  icon: icon(iconSrc),
  text: lines
})

export const buildAdvertisementContent = ({
  preset,
  title,
  occasion,
  image,
  closed,
  reopens,
  substitutes,
  emergencyText,
  signature
}) => {
  const occasionContent = occasionPresets[preset] || occasionPresets.easter
  const modalTitle = title || occasionContent.title || `Wegen ${occasion} geschlossen`
  const modalImage = image || occasionContent.image

  return {
    identifier: 'advertisement',
    text: [
      text(`**${modalTitle}**`, {
        color: ICON_COLOR,
        variant: 'h2',
        space: 2
      })
    ],
    images: [modalImage],
    collection: [
      listItem(icons.calendar, [
        text(`Vom ${closed.from} bis ${closed.to} bleibt die Praxis geschlossen`, {
          variant: 'h6',
          space: 1
        }),
        text('Vertretung übernehmen folgende Praxen:', { space: 1 })
      ]),
      ...substitutes
        .filter(({ enabled }) => enabled)
        .map(({ name, details }) =>
          listItem(icons.directions, [
            text(name, { variant: 'h6', space: 1 }),
            text(details, { space: 1 })
          ])
        ),
      listItem(icons.check, [
        text(emergencyText, { space: 1 }),
        text(
          `Ab ${reopens.weekday}, den ${reopens.date} sind wir ab 08:00 Uhr wieder für Sie da.`,
          {
            variant: 'h6',
            space: 1
          }
        ),
        text(signature)
      ])
    ]
  }
}
